/* global bootstrap */
import "./contact-us.scss";

const SELF_SERVICE_REQUEST_TYPES = ["add_to_order", "contactus_change", "change_shipping_address"];
// Request types that trigger the AJAX eligibility pre-flight. Cancellation is
// checked for a denial reason before submit but stays out of SELF_SERVICE_REQUEST_TYPES
// so it never opens the cancel-and-reclone confirmation modal.
const ELIGIBILITY_CHECK_REQUEST_TYPES = [...SELF_SERVICE_REQUEST_TYPES, "contactus_cancel"];

const showConfirmationModal = modalHtml => {
  // Create temporary container for modal HTML
  const $tempContainer = document.createElement("div");
  $tempContainer.innerHTML = modalHtml;
  document.body.appendChild($tempContainer);

  // Find the modal element
  const $modal = $tempContainer.querySelector(".js-contactus-confirmation-modal");
  if (!$modal) {
    return;
  }

  // Initialize the modal component
  if (window.initContactusConfirmationModal) {
    window.initContactusConfirmationModal();
  }

  // Show the modal using Bootstrap
  if (typeof $ !== "undefined" && $.fn && $.fn.modal) {
    $($modal).modal("show");
  } else if (typeof bootstrap !== "undefined") {
    const modal = new bootstrap.Modal($modal);
    modal.show();
  }

  // Clean up temporary container when modal is hidden
  const cleanupModal = () => {
    $tempContainer.remove();
  };

  if (typeof $ !== "undefined" && $.fn && $.fn.modal) {
    $($modal).on("hidden.bs.modal", cleanupModal);
  } else {
    $modal.addEventListener("hidden.bs.modal", cleanupModal);
  }
};

const showDenialMessage = ($contactUsForm, denialInfo) => {
  $contactUsForm.parentElement
    ?.querySelectorAll(".js-add-to-order-denial")
    .forEach(el => el.remove());

  const $alert = document.createElement("div");
  $alert.className = "alert alert-warning js-add-to-order-denial";
  $alert.setAttribute("role", "alert");

  const message = denialInfo.message || "This order is not eligible for add-to-order.";
  const alternative = denialInfo.alternative || "";
  $alert.textContent = alternative ? `${message} ${alternative}` : message;

  $contactUsForm.insertAdjacentElement("beforebegin", $alert);
};

const submitFormAjax = ($form, formData) => {
  // Ensure we use the same protocol as the current page
  let actionUrl = $form.action;
  if (window.location.protocol === "https:" && actionUrl.startsWith("http:")) {
    actionUrl = actionUrl.replace("http:", "https:");
  }

  // Get CSRF token from meta tag
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");

  return fetch(actionUrl, {
    method: "POST",
    body: formData,
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      Accept: "application/json",
      "X-CSRF-Token": csrfToken || ""
    },
    credentials: "same-origin"
  });
};

const findContactUsForm = () => {
  // Find the contact us form
  let $contactUsForm = document.querySelector(".contact-us form");
  if (!$contactUsForm) {
    $contactUsForm = document.querySelector("form[action*='contactus']");
  }
  if (!$contactUsForm) {
    const $formContainer = document.querySelector(".contact-us__form");
    if ($formContainer) {
      $contactUsForm = $formContainer.closest("form");
    }
  }
  return $contactUsForm;
};

const processAjaxResponse = async ($contactUsForm, response) => {
  // Check if response is ok
  if (!response.ok) {
    $contactUsForm.submit();
    return;
  }

  const responseText = await response.text();
  let data;

  try {
    data = JSON.parse(responseText);
  } catch (e) {
    $contactUsForm.submit();
    return;
  }

  if (data.show_modal) {
    $contactUsForm.parentElement
      ?.querySelectorAll(".js-add-to-order-denial")
      .forEach(el => el.remove());
    showConfirmationModal(data.modal_html);
  } else if (data.denial_message) {
    showDenialMessage($contactUsForm, data.denial_message);
  } else if (data.redirect_url) {
    // Redirect to the specified URL
    window.location.href = data.redirect_url;
  } else {
    // Submit form normally
    $contactUsForm.submit();
  }
};

const handleSelfServiceSubmit = async ($contactUsForm, event) => {
  const $requestSelect = $contactUsForm.querySelector('select[name="request"]');
  const $orderNumberField = $contactUsForm.querySelector('[name="order_number"]');

  if (!$requestSelect || !$orderNumberField) {
    return;
  }

  const requestType = $requestSelect.value;
  const orderNumber = $orderNumberField.value;

  // Check if this request type runs the eligibility pre-flight with an order number
  if (ELIGIBILITY_CHECK_REQUEST_TYPES.includes(requestType) && orderNumber) {
    event.preventDefault();

    // Submit form via AJAX to check eligibility
    const formData = new FormData($contactUsForm);
    formData.append("check_self_service", "true");

    try {
      const response = await submitFormAjax($contactUsForm, formData);
      await processAjaxResponse($contactUsForm, response);
    } catch (error) {
      // On error, submit form normally
      $contactUsForm.submit();
    }
  }
};

const initContactUs = () => {
  const $contactUsForm = findContactUsForm();

  if (!$contactUsForm) {
    return;
  }

  // Remove existing event listener if present
  if ($contactUsForm.contactUsSubmitHandler) {
    $contactUsForm.removeEventListener("submit", $contactUsForm.contactUsSubmitHandler);
  }

  // Create and store the event handler
  $contactUsForm.contactUsSubmitHandler = event => {
    handleSelfServiceSubmit($contactUsForm, event);
  };

  // Add submit event listener
  $contactUsForm.addEventListener("submit", $contactUsForm.contactUsSubmitHandler);
};

// Try to initialize on DOMContentLoaded
document.addEventListener("DOMContentLoaded", () => {
  initContactUs();
});

// Also listen for turbolinks:load
document.addEventListener("turbolinks:load", () => {
  initContactUs();
});

export default initContactUs;
